const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 3600;

/** "3 h 12 min" from an hour on, "12 min 30 s" below, "45 s" under a minute; a missing duration shows "—". */
const formatAudioDuration = (totalSeconds: number | null): string => {
	if (totalSeconds === null) {
		return '—';
	}

	const hours = Math.floor(totalSeconds / SECONDS_PER_HOUR);
	const minutes = Math.floor((totalSeconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE);
	const seconds = Math.floor(totalSeconds % SECONDS_PER_MINUTE);

	if (hours > 0) {
		return `${hours} h ${minutes} min`;
	}

	if (minutes > 0) {
		return seconds > 0 ? `${minutes} min ${seconds} s` : `${minutes} min`;
	}

	return `${seconds} s`;
};

export default formatAudioDuration;
